import { list as getList } from "~/api/contractCustomerStorage";
import * as types from "../mutation-types";
import store from "../../store";
import { clearableStore } from "~/mixins/clearableStore";
import { generateStoreKey } from "~/utils/storeKeyGenerator";
import { ACTIVE, INACTIVE } from "~/constants/entityStatus";

export const state = {
  data: {},
  currentKey: null,
  isLoading: false,
  isInitialLoadPending: true
};

export const mutations = {
  [types.SET_IS_LOADING_CONTRACT_CUSTOMER](state, status) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_CUSTOMER](state, { key, data }) {
    state.data[key] = data;
    state.isInitialLoadPending = false;
  },
  [types.SET_CURRENT_CONTRACT_CUSTOMER_KEY](state, key) {
    state.currentKey = key;
  },
  [clearableStore.mutations.CLEAR_STORE_DATA](state) {
    state.data = {};
    state.currentKey = null;
    state.isInitialLoadPending = true;
    state.isLoading = false;
  }
};

/**
 * Actions
 */
export const actions = {
  fetchCustomers({ commit, state }, payload = {}) {
    let contractId = null;
    let includes = null;

    if (typeof payload === "string" || typeof payload === "number") {
      contractId = payload;
    } else if (payload && typeof payload === "object") {
      contractId = payload.contractId || null;
      includes = payload.includes || null;
    }

    const activeContractId =
      contractId || store.getters["contract/activeContract"]?.id;

    if (!activeContractId) {
      return Promise.resolve();
    }

    const key = generateStoreKey(activeContractId, includes);

    commit(types.SET_IS_LOADING_CONTRACT_CUSTOMER, true);

    return getList(activeContractId, { includes }).then((response) => {
      const { data } = response;
      commit(types.SET_CONTRACT_CUSTOMER, { key, data: data.data });
      commit(types.SET_CURRENT_CONTRACT_CUSTOMER_KEY, key);
      commit(types.SET_IS_LOADING_CONTRACT_CUSTOMER, false);
    }).catch((error) => {
      commit(types.SET_IS_LOADING_CONTRACT_CUSTOMER, false);
      throw error;
    });
  }
};

/**
 * Getters
 */
export const getters = {
  list: (state) => {
    return state.currentKey ? state.data[state.currentKey] : null;
  },
  listByKey: (state) => (contractId, includes = null) => {
    const key = generateStoreKey(contractId, includes);
    return state.data[key] || null;
  },
  listOfActive: (state) => {
    const list = state.currentKey ? state.data[state.currentKey] : null;
    return list ? list.filter((item) => item.statusId === ACTIVE) : [];
  },
  listOfInactive: (state) => {
    const list = state.currentKey ? state.data[state.currentKey] : null;
    return list ? list.filter((item) => item.statusId === INACTIVE) : [];
  },
  listOfStable: (state) => {
    const list = state.currentKey ? state.data[state.currentKey] : null;
    if (!list) return [];
    return list.filter(
      (item) => item.statusId === ACTIVE || item.statusId === INACTIVE
    );
  },
  isLoading: (state) => state.isLoading,
  isInitialLoadPending: (state) => state.isInitialLoadPending
};
